export default "__VITE_ASSET__DVbm7L2h__"